import Cookie from 'cookie-universal';

const cookies = Cookie();

interface CookieOptions {
  path: string;
  expires?: Date;
  encode?: (value: string) => string;
  secure?: boolean;
  sameSite?: 'lax' | 'none' | 'strict';
}

export const getCookie = (name: string) => cookies.get(name);

export const setCookie = (
  key: string,
  value: string,
  countDay?: Date,
  extraOptions?: Pick<CookieOptions, 'encode' | 'secure' | 'sameSite'>,
) => {
  const options: CookieOptions = { path: '/' };
  if (countDay) {
    options.expires = countDay;
  }
  if (extraOptions?.encode) {
    options.encode = extraOptions.encode;
  }
  if (extraOptions?.secure !== undefined) {
    options.secure = extraOptions.secure;
  }
  if (extraOptions?.sameSite) {
    options.sameSite = extraOptions.sameSite;
  }

  cookies.set(key, value, options);
};

export const removeCookie = (name: string) => {
  cookies.remove(name);
};
